import CryptoJS from 'crypto-js';

const AES = {
    // 加密（ECB模式，PKCS7填充）
    encrypt: (text, key) => {
        const utf8Key = CryptoJS.enc.Utf8.parse(key);
        const encrypted = CryptoJS.AES.encrypt(text, utf8Key, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        });
        return encrypted.toString();
    },
    // 解密 
    decrypt: (ciphertext, key) => {
        const utf8Key = CryptoJS.enc.Utf8.parse(key);
        const decrypted = CryptoJS.AES.decrypt(ciphertext, utf8Key, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        });
        return decrypted.toString(CryptoJS.enc.Utf8);
    }
};
export default AES;


// WEBPACK FOOTER //
// ./src/common/aes.js